// extracted by mini-css-extract-plugin
module.exports = {"title":"pointsReceivedBackCard_title__u0Np2","subTitle":"pointsReceivedBackCard_subTitle__1iuiw"};